import { Route } from "react-router-dom";
import Login from "@pages/auth/login";
import Maintenance from "@pages/maintenance";

export const authRoutes = [
  <Route key="login" path="/login" element={<Login />} />,
  <Route key="maintenance" path="/maintenance" element={<Maintenance />} />,
];
